import WithdrawHeader from 'components/Header/WithdrawHeader';
import HeadingComponent from 'components/HeadingComponent';
import React from 'react'
import { BgImg, WithdrawGameList } from './WithdrawStyled';
import Table from 'react-bootstrap/Table'
import { WithdrawGameListContent } from './WithdrawContent';
import { Container } from 'react-bootstrap';
import { NavLink } from 'components/Header/HeaderStyled';
import { Box } from 'components/Box';

const GamesList: React.FC = () => {

    return (
        <>
            <BgImg style={{ height: 'auto' }}>
                <WithdrawHeader />
                <Box style={{ marginBottom: "50px" }}>
                    <HeadingComponent>Games List</HeadingComponent>
                </Box>
                <Container>
                    <WithdrawGameList>
                        <Table>
                            <tbody>
                                {
                                    WithdrawGameListContent.map((WithdrawGameListContent) => (
                                        <tr key={WithdrawGameListContent.id}>
                                            <td>
                                                <img src={WithdrawGameListContent.img} alt='' />
                                            </td>
                                            <td>{WithdrawGameListContent.title}</td>
                                            <td>{WithdrawGameListContent.amount}</td>
                                            <td>
                                                <NavLink to='/withdrawdetail'>
                                                    <img src={WithdrawGameListContent.btn} alt='' />
                                                </NavLink>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </WithdrawGameList>
                </Container>
            </BgImg>
        </>
    )
}

export default GamesList;